<template>
  <div>
    <div class="actions">
    </div>
    <div  style="height: 500px">
      <!-- swiper1 -->
      <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop" :slides-per-view="4" :space-between="20">
        <swiper-slide class="slide-1"></swiper-slide>
        <swiper-slide class="slide-2"></swiper-slide>
        
        <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
        <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
      </swiper>
      <!-- swiper2 Thumbs -->
      
    </div>
  </div>
</template>


<script>

  import 'swiper/swiper-bundle.css'


import { swiper, swiperSlide } from 'vue-awesome-swiper'

  export default {
       components: {
      swiper,
      swiperSlide
    },
    name:'slider',
    data() {
      return {
        swiperOptions: {
          breakpoints: {      
            320: {       
              slidesPerView: 1,
              spaceBetween: 10     
            },
                  770: {       
              slidesPerView: 2,       
              spaceBetween: 50     
            },   
        
            771: {       
              slidesPerView: 4,       
              spaceBetween: 30     
            } 
          }
        },
        swiperOptionTop: {
          spaceBetween: 0,
          loop: true,
          loopedSlides: 3, //looped slides should be the same
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        swiperOptionThumbs: {
          spaceBetween: 3,
          slidesPerView: 4,
          touchRatio: 0.2,
          loop: false,
          loopedSlides: 5, //looped slides should be the same
          slideToClickedSlide: false,
        }
        
      }
    },
    mounted() {
      this.$nextTick(() => {
        const swiperTop = this.$refs.swiperTop.swiper
        const swiperThumbs = this.$refs.swiperThumbs.swiper
        swiperTop.controller.control = swiperThumbs
        swiperThumbs.controller.control = swiperTop
      })
    }
  }
</script>

<style lang="scss" scoped>
  .swiper-container {
    background-color:black;
  }
  .swiper-slide {
    background-size: cover;
    background-position: center;
    &.slide-1 {
      background-image:url('../assets/img/1.jpg');
    }
    &.slide-2 {
      background-image:url('../assets/img/2.jpg');
    }
    &.slide-3 {
      background-image:url('../assets/img/3.jpg');
    }
    &.slide-4 {
      background-image:url('../assets/img/4.jpg');
    }
    &.slide-5 {
      background-image:url('../assets/img/5.jpg');
    }
  }
  .gallery-top {
    height: 818px!important;
    width: 100%;
  }
  .gallery-thumbs {
    height: 20%!important;
    box-sizing: border-box;
    padding: 3px 0;
  }
  .gallery-thumbs .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
  }
  .gallery-thumbs .swiper-slide-active {
    opacity: 1;
  }
</style>